import * as z from "zod";
import { SourceTypeSchema } from "../enums/database-enums";
import {
  IntegrationPopupsConfigSchema,
  StorefrontFunnelSeoSchema,
  StorefrontFunnelSchema,
  StorefrontFunnelConfigSchema,
  StorefrontPageTreeSchema,
  StorefrontThemeConfigSchema,
} from "./storefront";

export const NamedFunnelVersionSchema = z.enum(["draft", "published", "version"]);
export type NamedFunnelVersion = z.infer<typeof NamedFunnelVersionSchema>;

export const PublishedFunnelVersionConfigSchema = StorefrontFunnelConfigSchema.pick({
  seo: true,
  integrationPopups: true,
});

/** A page's settings that save with its sections: its versioned config and creator. */
export const FunnelPageSettingsSchema = z.object({
  seo: StorefrontFunnelSeoSchema.optional(),
  integrationPopups: IntegrationPopupsConfigSchema,
  creatorId: z.number().optional(),
});
export type FunnelPageSettings = z.infer<typeof FunnelPageSettingsSchema>;

export const PublishedFunnelVersionSnapshotSchema = StorefrontFunnelSchema.pick({
  influencer: true,
  productSections: true,
  cartSections: true,
  program: true,
  featuredProduct: true,
  brandTokens: true,
}).extend({
  lastModified: z.string(),
  homePage: StorefrontPageTreeSchema.pick({ id: true, sections: true }),
  theme: StorefrontThemeConfigSchema.shape.theme.optional(),
  config: PublishedFunnelVersionConfigSchema.optional(),
  source: z
    .object({
      type: SourceTypeSchema,
      id: z.number().nullable(),
    })
    .optional(),
});
export type PublishedFunnelVersionSnapshot = z.infer<typeof PublishedFunnelVersionSnapshotSchema>;

export const PublishedFunnelVersionMetadataSchema = z.object({
  id: z.number(),
  funnelId: z.number(),
  version: z.number(),
  publishedAt: z.iso.datetime(),
  publishedBy: z.string().nullable(),
  publishedByName: z.string().nullable().optional(),
  restoredFromVersion: z.number().nullable(),
});
export type PublishedFunnelVersionMetadata = z.infer<typeof PublishedFunnelVersionMetadataSchema>;

export const PublishedFunnelVersionSchema = PublishedFunnelVersionMetadataSchema.extend({
  snapshot: PublishedFunnelVersionSnapshotSchema,
});
export type PublishedFunnelVersion = z.infer<typeof PublishedFunnelVersionSchema>;

export const RestoreFunnelVersionOutputSchema = PublishedFunnelVersionSchema.extend({
  hasMissingResources: z.boolean(),
});
export type RestoreFunnelVersionOutput = z.infer<typeof RestoreFunnelVersionOutputSchema>;
